import type { ValidationSearchParams } from '../../../api/types.js';
import {
  useAsyncValidationState,
  useDataConfigurationErrorsCount,
  useDataConfigurationRows,
  useDataFilePreview,
  usePlatformsCatalog,
} from '../../../queries/index.js';

export const useValidatedData = (
  dataFileId: string,
  params: ValidationSearchParams,
  options: { enabled: boolean },
) => {
  const { data: dataFilePreview } = useDataFilePreview(dataFileId);

  const isValidating = dataFilePreview.status === 'validating';

  const isReady = options.enabled && !isValidating;

  const errorsCountQuery = useDataConfigurationErrorsCount(dataFileId, {
    enabled: isReady,
    throwOnError: true,
  });

  const {
    data,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    isLoading: validatedRowsIsLoading,
  } = useDataConfigurationRows(dataFileId, params, {
    enabled: isReady,
    throwOnError: true,
  });

  const validationState = useAsyncValidationState(dataFileId);

  const { isPending: platformsIsLoading } = usePlatformsCatalog();

  return {
    isValidating,
    validationState,
    dataFilePreview,
    data,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    errorsCount: errorsCountQuery.data,
    isLoading:
      isValidating ||
      platformsIsLoading ||
      errorsCountQuery.isLoading ||
      validatedRowsIsLoading,
  };
};
